import { createContext, useContext } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { WhichWeightAPI } from 'WhichWeightAPI'
import { ModalKey, ModalContext } from 'components/Modals/ModalContext'
import { removeWorkoutFromActiveWorkouts } from 'redux/slices/activeWorkout'
import { resetAthleteProfileState } from 'redux/slices/athleteProfile'
import { resetOrganizationState } from 'redux/slices/organization'

export const ActiveWorkoutContext = createContext()

export const ActiveWorkoutContextProvider = ({ children }) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { ShowModal } = useContext(ModalContext)

    // Active Workout Functionality

    const __DiscardActiveWorkout = async (workoutId, profileType, groupId, athleteId, routeNavigateAfterDiscard = '') => {

        if (profileType === 'group') {
            try {
                const jsonBody = {
                    groupId: groupId,
                    workoutId: workoutId
                }
        
                // console.log(jsonBody)
        
                const result = await WhichWeightAPI('REPORTING', 'POST', '/group_workout_discard', jsonBody)
        
                // console.log(result)
        
                if (result.data.status === 'failure') {
                    console.error(result)
                    return
                }
        
                const discardPayload = {
                    profileType: profileType,
                    groupId: groupId,
                    athleteId: athleteId
                }

                // console.log(discardPayload)
        
                dispatch(removeWorkoutFromActiveWorkouts(discardPayload))

                if (routeNavigateAfterDiscard !== '') {
                    navigate(routeNavigateAfterDiscard)
                }

            } catch (error) {
                console.error(error)
                return
            }
        }

        if (profileType === 'individual') {
            try {
                const jsonBody = {
                    userId: athleteId,
                    workoutId: workoutId
                }
        
                // console.log(jsonBody)
        
                const result = await WhichWeightAPI('REPORTING', 'POST', '/workout_discard', jsonBody)
        
                // console.log(result)
        
                if (result.data.status === 'failure') {
                    console.error(result)
                    return
                }
        
                const discardPayload = {
                    profileType: profileType,
                    groupId: groupId,
                    athleteId: athleteId
                }

                // console.log(discardPayload)
        
                dispatch(removeWorkoutFromActiveWorkouts(discardPayload))

                if (routeNavigateAfterDiscard !== '') {
                    navigate(routeNavigateAfterDiscard)
                }

            } catch (error) {
                console.error(error)
                return
            }
        }
    }

    const __EndActiveWorkout = async (activeWorkout, routeNavigateAfterEnd = '') => {

        if (activeWorkout.profileType === 'group') {

            // Save workout template to backend

            const jsonBody = {
                groupId: activeWorkout.groupId,
                activeWorkout: activeWorkout
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'PATCH', '/complete_group_workout', jsonBody)

            // console.log(result)

            if (result.data.status == 'failure') {
                console.error(result)
                return
            }

        }

        if (activeWorkout.profileType === 'individual') {

            // Save workout template to backend

            const jsonBody = {
                userId: activeWorkout.athleteId,
                activeWorkout: activeWorkout,
                trackAthleteOnboardingChecklistStep: false
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('PROGRAM', 'PATCH', '/complete_workout_v2', jsonBody)

            // console.log(result)

            if (result.data.status == 'failure') {
                console.error(result)
                return
            }

        }

        // Remove specific active workout from active workouts array

        const removePayload = {
            profileType: activeWorkout.profileType,
            groupId: activeWorkout.groupId,
            athleteId: activeWorkout.athleteId
        }

        // console.log(removePayload)

        dispatch(removeWorkoutFromActiveWorkouts(removePayload))
        dispatch(resetAthleteProfileState())
        dispatch(resetOrganizationState())

        if (routeNavigateAfterEnd !== '') {
            navigate(routeNavigateAfterEnd)
        }

    }

    const DiscardActiveWorkoutWarningModal = (workoutId, profileType, groupId, athleteId, routeNavigateAfterDiscard = '') => {
        const modalData = {
            key: ModalKey.ActionWarning,
            fullscreen: false,
            size: 'quarter',
            titleText: 'Discard Workout?',
            bodyText: [
                'Are you sure you want to discard this active workout?',
                'Any progress made during the workout will be lost.'
            ],
            buttonText: 'Discard',
            buttonAction: async () => await __DiscardActiveWorkout(workoutId, profileType, groupId, athleteId, routeNavigateAfterDiscard)
        }

        ShowModal(modalData)
    }

    const EndActiveWorkoutWarningModal = (activeWorkout, routeNavigateAfterEnd = '') => {
        const modalData = {
            key: ModalKey.ActionWarning,
            fullscreen: false,
            size: 'quarter',
            titleText: 'End Workout?',
            bodyText: [
                'Are you sure you want to end this workout?',
                'All saved sets will be stored.',
                'Any incomplete or skipped sets will be discarded.'
            ],
            buttonText: 'End',
            buttonAction: async () => await __EndActiveWorkout(activeWorkout, routeNavigateAfterEnd)
        }

        ShowModal(modalData)
    }

    const ResumeActiveWorkout = (profileType, groupId, athleteId) => {
        if (profileType === 'group') {
            navigate(`/active/workout/group/${groupId}`)
        }
        
        if (profileType === 'individual') {
            navigate(`/active/workout/individual/${athleteId}`)
        }
    }

    const coachDashboardContextData = {
        // Active Workout Functionality
        DiscardActiveWorkoutWarningModal,
        EndActiveWorkoutWarningModal,
        ResumeActiveWorkout
    }

    return (
        <ActiveWorkoutContext.Provider 
            value={coachDashboardContextData}
        >
            {children}
        </ActiveWorkoutContext.Provider>
    )
}
